module.exports = __webpack_public_path__ + "static/media/inventory-management.18b0fb33.svg";